export * from './components/index'
export * from './tokens/index'
export * from './hooks/index'
export * from './utils/index'

import packageJson from './package.json'
console.info(' Pangu-components-plus is installed, version:', packageJson.version)

export { panguComponentPlus as default } from './install'
